<template>
  <div class="card card-sm" id="wish-info">
    <div class="card-header">
      <div class="common-info">
        <div class="row align-items-center">
          <div class="col-auto">
            <span class="bg-primary text-white avatar">
              <img
                  alt=""
                  width="50"
                  :src="props.payload.user_avatar"
              >
            </span>
          </div>
          <div class="col">
            <div class="font-weight-medium">
              <div class="user-source">
                <div><b>{{ props.payload.user_name }}</b></div>
              </div>
            </div>
            <div class="text-muted">
              <b>
                <span class="published">Создан</span>
                <span v-html="props.payload.wish_created_formatted"/>
              </b>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineOptions} from "vue"

defineOptions({
  name: "WishlistInfo"
})

const props = defineProps({
  payload: {
    type: Object,
    default: () => ({
      user_name: null,
      wish_created_formatted: null,
      user_avatar: () => {
        return null
      },
    }),
  },
})
</script>

<style scoped src="./style.css"></style>
